export default __webpack_public_path__ + "static/media/logo_heart.fddde582.svg";